import React, { useState } from 'react'
import office from '../imgs/office.jpg'
import mohamed from '../imgs/mohamedAbotaleb.jpg'
import Divider from '../components/Divider'
import '../css/aboutUs.css'
import { api } from '../api'
import { useContext } from 'react'
import { FaSpinner } from 'react-icons/fa6';

const About = () => {
  const { t, language } = useContext(api)
  const [iframeError, setIframeError] = useState(false)

  const handleIframeError = () => {
    setIframeError(true)
    console.log("Iframe Error Occurred")
  }

  const retryLoadIframe = () => {
    setTimeout(() => {
      setIframeError(false);
    }, 3000); // Retry after 3 seconds
  };  

  return (
    <main>
      {/* Landing */}
      <section className="landingBackg">
        <img src={office} alt="GroupPhoto" className="groupPhoto" />
        <div className="backgcover">
          <h1 className="landingTitle">{t("aboutUs")}</h1>
        </div>
      </section>
      {/* Founder */}
      <section className="founderSection" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
        <div className="founderText">
          <h2>{t("meetFounder")}</h2>
          <p>{t("meetFounderText")}</p>
        </div>
        <div className="founderInfo">
          <img src={mohamed} alt="" width={"400px"} height={"400px"}/>
          <p>{t("founderName")}</p>
        </div>
      </section>
      <Divider />
      {/* Location */}
      <section className="locationSection">
        <div className="locationHeaderContainer">
          <div className="locationHeaderLine"></div>
          <h2>{t("locationH2")}</h2>
          <div className="locationHeaderLine"></div>
        </div>
        <address>{t("address")}</address>
        <div className="frameContainer">
          <FaSpinner className='wheel' fill='black' />
          <iframe 
            className="locationFrame"
            title="Google Maps Embed of United Group Location"
            src={
              language === 'ar' 
                ? "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d280660.1544489421!2d31.3238415!3d30.0288577!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583e105b972313%3A0xb16df3cac91ac1b5!2sUNITED%20GROUP!5e1!3m2!1sar!2seg!4v1736169917275!5m2!1sar!2seg"
                : "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d280660.1544489421!2d31.3238415!3d30.0288577!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583e105b972313%3A0xb16df3cac91ac1b5!2sUNITED%20GROUP!5e1!3m2!1sen!2seg!4v1736169917275!5m2!1sen!2seg"
            }
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={() => {
              handleIframeError();
              retryLoadIframe();        
            }}
          />
          {iframeError && (
            <p style={{padding: "2rem", color: "crimson", fontSize: "clamp(.7rem, 2vw, 1rem)"}}>
              Failed to load Google Maps. <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">Open in new tab</a>
            </p>
          )}

        </div>
      </section>
    </main>
  )
}

export default About